export const PIN_TOOLTIP_TYPE = 'tooltip';
export const PIN_BUTTON_TYPE = 'button';
export const GROUP_TYPE = 'group';
